<template>
  <sp-date-picker
    v-preserve-properties:min-date="today"
    v-preserve-properties:open-to-date="openToDate"
    v-preserve-properties:day-states="dayStates"
    :disabled="disabled"
    class="availability-specific-day-picker"
    inline
    :value.attr="date"
    :focus-on-ready="indicators"
    :aria-label="label"
    :data-testid="TestId.finder.availabilityCalendar"
    :day-test-id="TestId.finder.availabilityCalendarDay"
    :prev-month-test-id="TestId.finder.availabilityCalendarPrevMonth"
    :next-month-test-id="TestId.finder.availabilityCalendarNextMonth"
    @change="handleChange"
    @visible-range="handleVisibleRange"
  ></sp-date-picker>
</template>

<script setup>
import { vPreserveProperties } from "#ce/utils/property-bindings";
import { computed } from "vue";
import { format } from "date-fns";
import { firstDetail } from "#ce/utils/events";
import { toBoolean, emptyToUndefined } from "#ce/utils/props";
import { TestId } from "#/test-ids";

const emit = defineEmits(["select", "visible-range"]);

const props = defineProps({
  disabled: { type: Boolean, default: false },
  /** The selected `available_date`, as `yyyy-MM-dd`. */
  date: {
    type: String,
    default: undefined,
  },
  /** The `sp-date-picker` day states, keyed by `yyyy-MM-dd`. */
  dayStates: {
    type: Object,
    default: () => ({}),
  },
  /** Whether day indicators are fetched; the calendar then takes focus so arrow keys drive it. */
  indicators: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    required: true,
  },
});

const today = format(new Date(), "yyyy-MM-dd");

const openToDate = computed(() => props.date ?? today);

function handleChange(event) {
  if (toBoolean(props.disabled)) {
    return;
  }
  emit("select", emptyToUndefined(firstDetail(event)));
}

function handleVisibleRange(event) {
  if (toBoolean(props.disabled)) {
    return;
  }
  emit("visible-range", firstDetail(event));
}
</script>

<style lang="scss" scoped>
.availability-specific-day-picker {
  display: block;
  width: 100%;
}
</style>
